import React from 'react';

const CompanyListTabs = ({ activeTab, setActiveTab, counts }) => {
  return (
    <div className="row">
      <div className="col-12">
        <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
          <li className="nav-item">
            <button
              className={`nav-link px-3 py-3 ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => setActiveTab('all')}
            >
              <div className="d-flex align-items-center">
                <span className="me-2">All Companies</span>
              </div>
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link px-3 py-3 ${activeTab === 'active' ? 'active' : ''}`}
              onClick={() => setActiveTab('active')}
            >
              <div className="d-flex align-items-center">
                <span className="me-2">Active</span>
              </div>
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link px-3 py-3 ${activeTab === 'inactive' ? 'active' : ''}`}
              onClick={() => setActiveTab('inactive')}
            >
              <div className="d-flex align-items-center">
                <span className="me-2">Inactive</span>
              </div>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CompanyListTabs;

